<template>
  <div class="wrapper" id="login">
    <div class="login-content d-flex justify-content-center">
      <div class="inner d-flex flex-column justify-content-between">
        <img src="/static/als-logo.png" class="branding" al="ALS Logo">
        <div class="login-form">
          <h2>New Password</h2>
          <p>{{ passwordOK }}</p>
          <form>
            <div class="form-group" v-if="!this.reset">
              <label>Email Address</label>
              <input type="text" v-model="emailAddress" class="form-control" id="emailAddressField">
            </div>
            <div class="form-group" v-if="!this.reset">
              <label>Password</label>
              <input type="password" v-model="password" class="form-control" id="passwordField">
            </div>
            <div class="form-group" v-if="!this.reset">
              <label>Please enter again</label>
              <input type="password" v-model="password1" class="form-control" id="password1Field">
            </div>
            <div class="form-group">
              <button
                type="button"
                class="btn btn-success"
                id="resetButton"
                @click="setUserPassword"
                :disabled="!goodToGo"
                v-if="!reset"
              >Reset Password</button>
              <button
                type="button"
                class="btn btn-outline-secondary ml-2"
                @click="backToLogin"
                id="cancelButton"
                v-if="!reset"
              >Cancel</button>
            </div>
          </form>
          <div class="form-group" v-if="reset">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="backToLogin"
              id="backtologinButton"
            >Back to login page</button>
          </div>
        </div>

        <div class="copyright-footer">&copy; 2024 Analytica Laboratories Limited T/A ALS NZ</div>
      </div>
    </div>
    <div class="login-image"/>
  </div>
</template>

<script>
import router from "@/router";
import { resetPasswordRedemption } from "@/services/api";

export default {
  name: "ResetPasswordRedemption",
  data: () => ({
    password: "",
    password1: "",
    emailAddress: "",
    failed: false,
    reset: false
  }),
  computed: {
    passwordOK: function() {
      if (this.reset) return "Your password has been set successfully";
      if (this.failed)
        return "There was an error setting your password, please try again";
      if (!this.password && !this.password1) return "";
      const acceptable = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(
        this.password
      );
      if (!acceptable)
        return "Passwords must be 8 or more characters and must have at least one number, one upper case letter and one lower case letter";
      if (this.password !== this.password1) return "Passwords must match";
      return "";
    },
    goodToGo: function() {
      return (
        this.passwordOK === "" &&
        this.password.trim().length > 0 &&
        this.emailAddress.trim().length > 0
      );
    }
  },
  methods: {
    backToLogin: () => {
      router.push("login");
    },
    setUserPassword: async function() {
      try {
        await resetPasswordRedemption(
          this.emailAddress,
          this.password,
          this.$route.query.token
        );
        this.failed = false;
        this.reset = true;
      } catch (e) {
        this.failed = true;
        this.reset = false;
      }
    }
  }
};
</script>
<style lang="scss">
@import "../assets/styles/main.scss";

.wrapper {
  height: 100vh;
}

.login-content {
  height: 100%;
  width: 50%;
  float: left;
  h2 {
    margin-bottom: 20px;
  }
  .branding {
    width: 200px;
  }
  .inner {
    width: 500px;
    height: 100%;
    padding: 50px;
  }
}

.login-image {
  position: relative;
  background-image: url("../../static/login-photo.jpg");
  background-size: cover;
  background-position: 50% 50%;
  height: 100%;
  width: 50%;
  float: left;
  z-index: 1;
  &::before {
    content: "";
    display: block;
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: -webkit-linear-gradient(bottom, $brand-primary, $brand-gray);
    opacity: 0.7;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ResetPasswordRedemption.vue